import api from './api';

export default {
  async getMonthlyPerformance() {
    try {
      const response = await api.get('/monthly-performance/', { authRequired: true });
      return response.data;
    } catch (error) {
      return [];
    }
  },
  async getTableData(startDate = "", endDate = "") {
    try {
      const params = {
        start_date: startDate || "",
        end_date: endDate || ""
      };
      const response = await api.get('/executed-orders/', { params, authRequired: true });
      return response.data;
    } catch (error) {
      return [];
    }
  }
};
